export const roundPrice = (price: number) => {
  return Math.round(price * 100) / 100;
};


// WEBPACK FOOTER //
// ./src/helpers/prices/roundPrice.ts